import {FC, memo} from 'react';
import {Box, Center} from '@chakra-ui/react';
import {getIsTodayString} from '@kcast-fe/core';

interface IProps {
  createdAt: string;
}

// Day separator pill. The caller decides where it appears (in-flow between
// messages, or the single stuck copy above the list).
const DayInfoFC: FC<IProps> = ({createdAt}) => {
  return (
    <Center p={'8px 0'}>
      <Box
        p={'2px 10px'}
        bg={'{colors.textPrimarySuperLight}'}
        color={'{colors.white}'}
        borderRadius={'full'}
        fontSize={'14px'}
      >
        {getIsTodayString(createdAt)}
      </Box>
    </Center>
  );
};

export const DayInfo = memo(DayInfoFC);
